import Idasen from "@inter-ikea-range/idasen";
import Mittzon from "@inter-ikea-range/mittzon";
import Propping from "@inter-ikea-range/propping";
import TableBarSystem from "@inter-ikea-range/table-bar-system";
import Trotten from "@inter-ikea-range/trotten";
import WorkspaceExperience from "@inter-ikea-range/workspace-experience";

import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";

// room experience
export const workspaceExperience = (settings: EnvironmentSettings) => WorkspaceExperience(settings);

// range packages
export const workspacePackages = (settings: EnvironmentSettings): Experience[] => [
  Idasen(settings),
  Mittzon(settings),
  TableBarSystem(settings),
  Trotten(settings),
  Propping(settings),
];
